import {ref, onMounted, watch} from 'vue'
import DevoirDeConseilService from "src/modules/devoir-de-conseil/services/devoir-de-conseil.service";

/**
 * Code contenant la logique pour récupérer les villes associées à un code postal donné
 *
 * @param codePostal
 * @returns {{cities: ToRef<*[]>, getCities: (function(): Promise<void>)}}
 */
export default function useCityRepositories(codePostal) {
    // Référence qui contiendra les villes disponibles par rapport au code postal donné
    const cities = ref([])

    // Appel API pour récupérer les villes disponibles par rapport au code postal donnée
    const getCities = async () => {
        cities.value = await DevoirDeConseilService.getCities(codePostal.value).then(res => {
            const cities = []
            for (const city of res.data.villes) {
                cities.push({'label': city, 'value': city})
            }
            console.debug('[useCityRepository]', 'getCities', cities)

            return cities
        })
    }

    // Si on a un code postal, on regarde les villes disponibles dès que le composant est monté
    onMounted(() => {
        console.debug('[useCityRepository]', 'onMounted', codePostal)
        if (codePostal && codePostal.value.length === 5) {
            getCities()
        }
    })

    // On met un watcher sur le code postal, pour mettre à jour la liste des villes dès que celui-ci change
    watch(codePostal, (current) => {
        console.debug('[useCityRepository]', 'watcher', current)
        if (current && current.length === 5) {
            getCities()
        }
    })

    return {
        cities,
        getCities
    }
}
